const config = {
    "BASE_URL": "https://admin-api.epabs.bullnet.ng/api/admin/v1/"
};

export default config;
